import { render, staticRenderFns } from "./MySelect.vue?vue&type=template&id=1b73ef6a&"
import script from "./MySelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./MySelect.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MySelect.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports